import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputDateTime from '../../../FormFields/DateTime';
import Checkbox from '../../../FormFields/Checkbox';
import InputSelect from "../../../FormFields/Select";
import withConditionsAndTriggers from '../withConditionsAndTriggers';

export class DateTimeWidget extends React.PureComponent {
  renderConfigTab = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api ?  api.getFieldsVerbiage(internalField, 'label') : internalField.label }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputText label='Description' value={ api ?  api.getFieldsVerbiage(internalField, 'description') : internalField.description }
                   onChange={ (v) => changeFieldValue('description', v) }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('required', v) } label='Required'
                    checked={ internalField.required }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('photo', v) } label='Photo'
                    checked={ internalField.photo }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('notes', v) } label='Notes'
                    checked={ internalField.notes }
                    className='InputCheckbox_Block'/>
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, error, onChange, onError, withPortal, popperPlacement }  = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'Date Time Input'
    };
    return (
      <WrapperWidget {...props}>
        <div className='DateTimeWidget'>
          <InputDateTime
            disabled={ field.disabled }
            required={ field.required }
            value={ value }
            onChange={ onChange }
            onError={ onError }
            error={ error }
            withPortal={ withPortal }
            popperPlacement={ popperPlacement }
          />
        </div>
      </WrapperWidget>
    );
  }
}

export const DateTimeWidgetEditable = withConditionsAndTriggers(DateTimeWidget);